// extracted by mini-css-extract-plugin
export var caractere = "author-quote-module--caractere--31963";
export var content = "author-quote-module--content--897d4";
export var detailContainer = "author-quote-module--detailContainer--e7929";
export var detailText = "author-quote-module--detailText--ccf88";
export var image = "author-quote-module--image--8c098";
export var imageContainerLeft = "author-quote-module--imageContainerLeft--887b3";
export var imageContainerRight = "author-quote-module--imageContainerRight--6fa62";
export var jobPosition = "author-quote-module--jobPosition--11ebc";
export var jobPositionDetail = "author-quote-module--jobPositionDetail--0b3a2";
export var name = "author-quote-module--name--07571";
export var root = "author-quote-module--root--4dfc0";